import {useEffect} from 'react';

import type {ClientThread} from 'features/threads/types/extended';
import {useAppDispatch} from 'stores/redux_store';
import {updateThreadReadOnServer} from 'features/threads/actions/update_thread_read_on_server';
import {getCurrentTeamId} from 'mattermost-redux/selectors/entities/teams';
import {createThunkAction} from 'stores/create_thunk_action';
import {selectThreadById} from 'features/threads/selectors/select_thread_by_id';
import {getCurrentUserId} from 'mattermost-redux/selectors/entities/common';
import {getThreadPostFollowState} from 'features/threads/selectors/get_thread_post_follow_state';

const markThreadReadOnServer = (threadId: ClientThread['id']) =>
    createThunkAction('thread/actions/markThreadReadOnServer', (dispatch, getState) => {
        const state = getState();
        const currentTeamId = getCurrentTeamId(state);
        const currentUserId = getCurrentUserId(state);
        const thread = selectThreadById(state, threadId);

        if (!thread) {
            return;
        }

        dispatch(
            updateThreadReadOnServer({
                teamId: currentTeamId,
                userId: currentUserId,
                threadId,
                timestamp: Date.now(),
            }),
        );
    });

const onThreadViewerMount = (threadId: ClientThread['id']) => createThunkAction('threads/actions/onThreadViewerMount', (dispatch, getState) => {
    const state = getState();
    const thread = selectThreadById(state, threadId);

    if (!thread) {
        return;
    }

    const isFollowing = getThreadPostFollowState(state, threadId);
    const hasUnreadReplies = thread.unread_mentions > 0 || thread.unread_replies > 0;
    const hasOutdatedLastViewedAt = thread.last_viewed_at < thread.last_reply_at;
    const shouldUpdateThreadRead = hasUnreadReplies || hasOutdatedLastViewedAt;

    if (isFollowing && shouldUpdateThreadRead) {
        /**
         * При открытии треда мы сбрасываем состояния непрочитанности (делаем это на маунте)
         **/
        dispatch(markThreadReadOnServer(threadId));
    }
});

export function useMarkThreadRead(threadId: ClientThread['id']) {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(onThreadViewerMount(threadId));
    }, [threadId, dispatch]);
}
